const Ps = ({ active }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={active === "PS4" ? "svg svg__active" : "svg"}
    >
      <g clipPath="url(#clip0_54_1045)">
        <path d="M19.8226 14.3138C19.4313 14.8075 18.4738 15.1587 18.4738 15.1587L11.3538 17.7163V15.83L16.5938 13.9637C17.1888 13.7512 17.2801 13.4488 16.7963 13.2913C16.3138 13.1325 15.4401 13.1788 14.8463 13.3913L11.3538 14.6212V12.6637L11.5551 12.5962C11.5551 12.5962 12.5638 12.2387 13.9826 12.0813C15.4013 11.925 17.1388 12.1025 18.5026 12.6188C20.0401 13.1063 20.2126 13.8212 19.8226 14.3138ZM12.0313 11.1038V6.27875C12.0313 5.7125 11.9276 5.19125 11.3963 5.04375C10.9888 4.9125 10.7363 5.29125 10.7363 5.85625V17.9362L7.47882 16.9025V2.5C8.86382 2.7575 10.8813 3.365 11.9663 3.73125C14.7251 4.6775 15.6601 5.85625 15.6601 8.5125C15.6601 11.1012 14.0626 12.0825 12.0313 11.1025V11.1038ZM1.50132 15.635C-0.0761818 15.1875 -0.338682 14.2625 0.380068 13.73C1.04507 13.2375 2.17507 12.8675 2.17507 12.8675L6.84632 11.205V13.0988L3.48382 14.3025C2.89132 14.515 2.80007 14.8162 3.28257 14.975C3.76507 15.1325 4.63882 15.0875 5.23257 14.875L6.84507 14.2887V15.9837L6.52382 16.0375C4.84159 16.3099 3.11844 16.1713 1.50132 15.6337V15.635Z" />
      </g>
      <defs>
        <clipPath id="clip0_54_1045">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Ps
